import React from 'react';
import { PropTypes } from 'prop-types';
import SortableColumn from 'components/atoms/sortableColumn';

const HeaderRow = ({
  setSorts,
  activityTimeSort,
  ccmStatusSort,
  hasAccessToCareAgent,
}) => {
  const activityTimeSortHandler = () => {
    if (activityTimeSort === 'ASC') {
      setSorts({ activityTimeSort: 'DESC' });
      return;
    }

    setSorts({ activityTimeSort: 'ASC' });
  };

  const ccmStatusSortHandler = () => {
    if (ccmStatusSort === 'ASC') {
      setSorts({ ccmStatusSort: 'DESC' });
      return;
    }

    setSorts({ ccmStatusSort: 'ASC' });
  };

  return (
    <tr>
      <th>Patient Name</th>
      <th>DOB</th>
      <th>
        <div>
          Care Modules
          <br />
          ICD-10 Codes
        </div>
      </th>
      <th>Provider</th>
      {hasAccessToCareAgent && <th>Case Manager</th>}
      {hasAccessToCareAgent && <th>Admission Manager</th>}
      <th>Last Activity and Last Activity Date</th>
      <th>
        <SortableColumn
          title="Total Interactive Time"
          handler={activityTimeSortHandler}
          sort={activityTimeSort}
        />
      </th>
      <th>
        <SortableColumn
          title="Status"
          handler={ccmStatusSortHandler}
          sort={ccmStatusSort}
        />
      </th>
    </tr>
  );
};

HeaderRow.propTypes = {
  setSorts: PropTypes.func.isRequired,
  activityTimeSort: PropTypes.string,
  ccmStatusSort: PropTypes.string,
  hasAccessToCareAgent: PropTypes.bool,
};

export default HeaderRow;
